import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaSpinner, FaExclamationTriangle } from 'react-icons/fa';
import { guestApi } from '../../api/guestList';
import { toast } from 'react-toastify';
import { useAuthContext } from '../../context/AuthContext';

const BulkDeleteModal = ({ show, onHide, selectedRows, onBulkDeleteComplete }) => {
  const { isAuthenticated } = useAuthContext();

  const [submitting, setSubmitting] = useState(false);

  const handleBulkDelete = async () => {
    if (selectedRows.length === 0) {
      toast.warning('No guests selected for deletion');
      return;
    }

    setSubmitting(true);
    try {
      const ids = selectedRows.map(r => r.id);
      await guestApi.deleteMultipleGuests(ids);

      toast.success(`âœ… Successfully deleted ${selectedRows.length} guest(s)!`);
      onBulkDeleteComplete();
      onHide();
    } catch (err) {
      console.error('Bulk delete error:', err);
      if (err.response?.status === 200 || err.response?.status === 800) {
        toast.success(`âœ… Successfully deleted ${selectedRows.length} guest(s)!`);
        onBulkDeleteComplete();
        onHide();
      } else {
        const errorMsg = err.response?.data?.message || err.message || 'Failed to delete selected guests';
        toast.error(`âŒ ${errorMsg}`);
      }
    } finally {
      setSubmitting(false);
    }
  };

  
  if (!isAuthenticated) return null;

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0">
      </Modal.Header>
      <Modal.Body className="text-center pb-5">
        <FaExclamationTriangle className="text-warning mb-3" size={48} />
        <h4>Futa Wageni</h4>
        <p>Una uhakika unataka kufuta wageni <b>{selectedRows.length}</b> ulio wachagua?</p>
        <p className="text-danger small">Hatua hii haiwezi kurudishwa nyuma.</p>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button variant="secondary" onClick={onHide} className="px-4">
            Hapana, Ghairi
          </Button>
          <Button variant="danger" onClick={handleBulkDelete} disabled={submitting} className="px-4">
            {submitting ? <FaSpinner className="fa-spin" /> : 'Ndiyo, Futa Wote'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default BulkDeleteModal;
